import { useEffect, useState } from 'react';
import { Text } from '@mantine/core';
import { useConnectionState, useRoomContext } from '@livekit/components-react';
import { ConnectionState, type Room } from 'livekit-client';

export function formatDuration(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    const mm = String(m).padStart(2, '0');
    const ss = String(s).padStart(2, '0');
    if (h > 0) {
        return `${String(h).padStart(2, '0')}:${mm}:${ss}`;
    }
    return `${mm}:${ss}`;
}

type RoomWithInfo = { roomInfo?: { creationTime?: bigint | number } };

export function CallDuration() {
    const room = useRoomContext();
    const connectionState = useConnectionState(room);

    if (connectionState !== ConnectionState.Connected) {
        return null;
    }

    return <Elapsed room={room} />;
}

function Elapsed({ room }: Readonly<{ room: Room }>) {
    const [startTime] = useState(() => {
        // roomInfo — приватное поле livekit-client; creationTime в секундах (int64)
        const creationTime = (room as unknown as RoomWithInfo).roomInfo?.creationTime;
        return creationTime ? Number(creationTime) * 1000 : Date.now();
    });
    const [elapsed, setElapsed] = useState(() => Math.floor((Date.now() - startTime) / 1000));

    useEffect(() => {
        const interval = setInterval(() => {
            setElapsed(Math.floor((Date.now() - startTime) / 1000));
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [startTime]);

    return (
        <Text c="dimmed" component="span" fw={500} size="sm" style={{ fontVariantNumeric: 'tabular-nums' }}>
            {formatDuration(elapsed)}
        </Text>
    );
}
